import BootstrapTable from "react-bootstrap-table-next";
import {
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { cn } from "../../lib/utils";
import { LawyerConditon } from "../../lib/PermissionConditions";

const ExpandInvoicing = ({ expandData }) => {
  const { organizationData } = useOrganization();
  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData[i]?.id,

        vendor: expandData[i]?.vendor
          ? formatSubcontractorName(expandData[i]?.vendor)
          : "-",
        asset: expandData[i]?.asset ? expandData[i]?.asset?.name : "-",
        sub_asset: expandData[i]?.sub_asset
          ? expandData[i]?.sub_asset?.name
          : "-",
        contract: expandData[i]?.contract
          ? expandData[i]?.contract?.contract_number
          : "-",
        job: expandData[i]?.ts_job ? expandData[i]?.ts_job?.code : "-",
        task: expandData[i]?.ts_task ? expandData[i]?.ts_task?.code : "-",

        total_amount: expandData[i]?.total_amount
          ? `$${formatNumber(Number(expandData[i]?.total_amount))}`
          : "$0.00",

        processing_fee_code: expandData[i]?.processing_fee?.code
          ? `$${formatNumber(Number(expandData[i]?.processing_fee?.code))}`
          : "$0.00",

        processing_fee_amount: expandData[i]?.processing_fee_amount
          ? `$${formatNumber(Number(expandData[i]?.processing_fee_amount))}`
          : "$0.00",

        premium_code: expandData[i]?.premium?.code
          ? `$${formatNumber(Number(expandData[i]?.premium?.code))}`
          : "$0.00",

        premium_amount: expandData[i]?.premium_amount
          ? `$${formatNumber(Number(expandData[i]?.premium_amount))}`
          : "$0.00",

        sub_total_amount: expandData[i]?.total_amount
          ? `$${formatNumber(
              Number(expandData[i]?.processing_fee_amount) +
                Number(expandData[i]?.premium_amount) +
                Number(expandData[i]?.total_amount)
            )}`
          : "$0.00",

        discount_amount: expandData[i]?.discount_amount
          ? `$${formatNumber(Number(expandData[i]?.discount_amount))}`
          : "$0.00",

        amount: expandData[i]?.amount
          ? `$${formatNumber(Number(expandData[i]?.amount))}`
          : "$0.00",

        gst_amount: expandData[i]?.gst_amount
          ? `$${formatNumber(Number(expandData[i]?.gst_amount))}`
          : "$0.00",

        net_amount: expandData[i]?.net_amount
          ? `$${formatNumber(Number(expandData[i]?.net_amount))}`
          : "$0.00",
        description: expandData[i]?.description
          ? expandData[i]?.description
          : "",
      });
    }

    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  let columns = [
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "vendor",
    //   text: `${getModuleNamingBySlug(
    //     organizationData?.organizationData,
    //     "vendors",
    //     "Vendor"
    //   )}`,
    // },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "asset",
    //   text: `${getModuleNamingBySlug(
    //     organizationData?.organizationData,
    //     "assets",
    //     "Asset"
    //   )}`,
    // },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_asset",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "sub-assets",
        "Sub Asset"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "contract",
      text: "Contract",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "job",
      text: "Job",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "task",
      text: "Task",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_amount",
      text: "Amount(Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "processing_fee_amount",
      text: "Fees",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "premium_amount",
      text: "Buyer's Premium",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_total_amount",
      text: "Sub Total(Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "discount_amount",
      text: "Discount",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount(Exc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "gst_amount",
      text: "Tax",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "net_amount",
      text: "Net Amount(Inc)",
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "description",
      // text: "Description",
      text: (LawyerConditon(organizationData) ? "Matter Description" : "Description"),
    },
  ];

  if (LawyerConditon(organizationData)) {
    columns = columns?.filter(
      (item) => item.dataField !== "job" && item.dataField !== "task"
    );
  }

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </div>
    </>
  );
};

export default ExpandInvoicing;
